module.exports = __webpack_public_path__ + "static/media/lettuce2.00c7e1ad.svg";